import HotBook from "component/user/hot_book";
import HomePage from "./pages/users/home";
import MasterLayout from "./pages/users/theme/masterLayout";
import { ROUTERS } from "./utils/router";
import { Routes, Route, useNavigate } from "react-router-dom";
import BestSellerBooks from "component/user/best_seller";
import LoginForm from "component/user/LoginRegister";
import RegisterForm from "component/user/Register/RegisterForm";
import ProductDetails from "pages/users/product_details";
import CartItems from "pages/users/cartItems";
import CheckCode from "component/user/checkCode";
import ConfirmOrder from "pages/users/confirmOrder";
import ProductListing from "pages/users/product_listing";
import PersonalInfor from "component/user/personal_infor";
import OrderSuccess from "component/user/order_success";
import Payment_Online from "component/user/payment_online/Payment_Online";

import { useLocation } from "react-router-dom";
import Dashboard from "component/admin/dashboard";
import AddBook from "pages/admin/addBook";
import BookList from "pages/admin/listBook";
import CategoryList from "pages/admin/listCategory";
import OrderList from "pages/admin/listOrder";
import Order_details from "pages/users/order_details/order_details";
import CancelPayment from "pages/users/cancelPayment/CancelPayment";
import OrderStatus from "pages/users/OrderStatus/OrderStatus";
import VerifyEmail from "component/user/verify_email/VerifyEmail";
import UpdateBook from "pages/admin/updateBook";
import { useEffect, useState } from "react";
import ReviewList from "pages/admin/listReview";
import {
  checkTokenExpiration,
  introspective,
  refreshToken,
  setupTokenRefresh,
} from "services/tokenService";
import ForgotPassword from "component/user/forgot_password/ForgotPassword";
import ResetPassword from "component/user/reset_password/ResetPassword";

import { CartProvider } from "context/CartContext";

import ProductSearch from 'component/user/search';
import AdminLayout from 'pages/admin/theme/adminLayout';

// import CategoryList from 'pages/admin/listCategory';
// import OrderList from 'pages/admin/listOrder';
// import Order_details from 'pages/users/order_details/order_details';
// import CancelPayment from 'pages/users/cancelPayment/CancelPayment';
// import OrderStatus from 'pages/users/OrderStatus/OrderStatus';
// import VerifyEmail from 'component/user/verify_email/VerifyEmail';

// import BookInfoForm from 'component/admin/bookInfoForm';
// import UpdateBook from 'pages/admin/updateBook';
// import { useEffect } from 'react';
// import ReviewList from 'pages/admin/listReview';
// import { checkTokenExpiration, refreshToken, setupTokenRefresh } from 'services/tokenService';
import RevenueStatistics from 'pages/admin/revenueStatistics/index.js';
import PageNotFound from "pages/pageNotFound";
import CampaignManagement from "pages/admin/campaignManage";
import BookDetail from "component/admin/book_detail";
import Privacy_Policy from "pages/users/privacyPolicy/Privacy_Policy";
import CustomerList from "pages/admin/listCustomer";
import AdminList from "pages/admin/listAdmin";
import ChangePassword from "pages/admin/changePassword/changePassword";
import CancelOrder from "pages/users/cancelOrder/CancelOrder";
import MyAccount from "pages/admin/myAccount/myAccount";

const renderUserRouter = () => {
    const userRouters = [
        {
          path: ROUTERS.USER.HOME,
          component: <HomePage />,
        },

        {
          path: ROUTERS.USER.PROFILE,
          component: <HomePage />,
        },

        {
          path: ROUTERS.USER.HOT_BOOK,
          component: <HotBook />,
        },

        {
          path: ROUTERS.USER.BEST_SELLER_BOOK,
          component: <BestSellerBooks />,
        },

        {
          path: ROUTERS.USER.SIGNIN,
          component: <LoginForm />,
        },

        {
          path: ROUTERS.USER.REGISTER,
          component: <RegisterForm />,
        },

        {
          path: ROUTERS.USER.PRODUCT_DETAILS,
          component: <ProductDetails />,
        },

        {
          path: ROUTERS.USER.CARTITEMS,
          component: <CartItems />,
        },

        {
          path: ROUTERS.USER.CONFIRMORDER,
          component: <ConfirmOrder />,
        },

        {
          path: ROUTERS.USER.PRODUCT_LISTING,
          component: <ProductListing />,
        },
        {
          path: ROUTERS.USER.PERSONAL_INFOR,
          component: <PersonalInfor />,
        },
        {
          path: ROUTERS.USER.ORDER_SUCCESS,
          component: <OrderSuccess />,
        },
        {
          path: ROUTERS.USER.PAYMENT_ONLINE,
          component: <Payment_Online />,
        },

        {
          path: ROUTERS.USER.PRODUCT_SEARCH,
          component: <ProductSearch />,
        },

        {
          path: ROUTERS.USER.ORDER_DETAILS,
          component: <Order_details />,
        },

        {
          path: ROUTERS.USER.CANCEL_PAYMENTLINK,
          component: <CancelPayment />,
        },
        {
          path: ROUTERS.USER.ORDER_STATUS,
          component: <OrderStatus />,
        },
        {
          path: ROUTERS.USER.VERYFI_EMAIL,
          component: <VerifyEmail />,
        },
        {
          path: ROUTERS.USER.FORGOT_PASSWORD,
          component: <ForgotPassword />,
        },
        {
          path: ROUTERS.USER.RESET_PASSWORD,
          component: <ResetPassword />,
        },
        {
          path: "*",
          component: <PageNotFound />,
        },
        {
          path: ROUTERS.USER.PRIVACY_POLICY,
          component: <Privacy_Policy />,
        },
        {
          path: ROUTERS.USER.CANCEL_ORDER,
          component: <CancelOrder />,
        },
       
        
    ];

    return (
        <MasterLayout>
          <CheckCode />
          <Routes>
            {userRouters.map((item, key) => (
              <Route key={key} path={item.path} element={item.component} />
            ))}
          </Routes>
        </MasterLayout>
    );
}
const renderAdminRouter = () => {
    const adminRouters = [
        {
            path: ROUTERS.ADMIN.DASHBOARD,
            component: <Dashboard/>
        },
        {
            path: ROUTERS.ADMIN.ADD_BOOK,
            // component: <AddBook/>
            component: <AddBook/>
        },
        {
            path: ROUTERS.ADMIN.UPDATE_BOOK,
            component: <UpdateBook/>
        },
        {
            path: ROUTERS.ADMIN.LIST_BOOK,
            component: <BookList/>
        },
        {
            path: ROUTERS.ADMIN.LIST_CATEGORY,
            component: <CategoryList/>
        },
        {
            path: ROUTERS.ADMIN.LISTORDER,
            component: <OrderList/>
        },
        {
            path: ROUTERS.ADMIN.LIST_REVIEW,
            component: <ReviewList/>
        },
        {
            path: ROUTERS.ADMIN.REVENUE_STATISTICS,
            component: <RevenueStatistics/>
        },
        {
          path: ROUTERS.ADMIN.CAMPAIGN,
          component: <CampaignManagement/>
        },
        {
          path: ROUTERS.ADMIN.BOOK_DETAILS,
          component: <BookDetail/>
        },
        {
          path: ROUTERS.ADMIN.ADMIN_MANAGEMENT,
          component: <AdminList/>
        },
        {
          path: ROUTERS.ADMIN.LIST_CUSTOMER,
          component: <CustomerList/>
        },
        {
          path: ROUTERS.ADMIN.CHANGE_PASSWORD,
          component: <ChangePassword/>
        },
        {
          path: ROUTERS.ADMIN.MY_ACCOUNT,
          component: <MyAccount/>
        }
        // {
        //   path: "*",
        //   component: <PageNotFound/>
        // },
    ]

    return (
        <AdminLayout>
            <Routes>
                {
                    adminRouters.map((item, key) => (
                        <Route key={key} path={item.path} element={item.component} />
                    ))
                }
            </Routes>
        </AdminLayout>

    )
}
const RouterCustom = () => {
    const [role, setRole] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        checkTokenExpiration(navigate);
    }, [navigate]);

    // useEffect(() => {
    //     const fetchRole = async () => {
    //         const token = localStorage.getItem("token");

    //         if (!token) {
    //           return;
    //         }
            
    //         setIsLoading(true);
    //         try {
    //             const response = await introspective(token);
    //             if (response.data) {
    //                 setRole(response.data.role);
    //             }
    //         } 
    //         catch (error) {
    //             console.log("introspective failed:", error);
    //             navigate("/login");
    //         }  
    //         finally {
    //             setIsLoading(false);
    //         }
    //     };

    //     fetchRole();

    // }, [navigate]);
    // console.log(role)

    // admin
    const location = useLocation();

    useEffect(() => {
        if (location.pathname.startsWith('/admin')) {
            if (localStorage.getItem("role") !== "superadmin" && localStorage.getItem("role") !== "admin") {
                navigate("/login");
            }
        }
    }, [location.pathname, navigate]);

    if (location.pathname.startsWith('/admin') && (localStorage.getItem("role") === "superadmin" || localStorage.getItem("role") === "admin")) {
        return renderAdminRouter();
    }

    // user
    // if (!location.pathname.startsWith('/admin')) {
    //     return renderUserRouter();
    // }
    return renderUserRouter();
};



export default RouterCustom;
